<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconBurger"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
        <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
